export const getIsVerified = () => {
  return localStorage.getItem('isVerified') === 'true';
}

export const setIsVerified = (value) => {
  localStorage.setItem('isVerified', String(value));
}

export const getIsFillProfile = () => {
  return localStorage.getItem('isFillProfile') === 'true';
}

export const setIsFillProfile = (value) => {
  localStorage.setItem('isFillProfile', String(value));
}

// Есть ли у пациента карты профосмотра ВЭК (HAS_VEK из get_user_data).
// В отличие от isVerified / isFillProfile у флага три состояния: true / false / null -
// null означает «ещё не спрашивали» (после входа и после подтверждения учётной записи),
// по нему MainPage понимает, что данные пользователя нужно запросить.
export const getHasVek = () => {
  const value = localStorage.getItem('hasVek');
  return value === null ? null : value === 'true';
}

export const setHasVek = (value) => {
  if (value === null || value === undefined) {
    localStorage.removeItem('hasVek');
    return;
  }
  localStorage.setItem('hasVek', String(value));
}
